<ng-container *ngFor="let message of messageList; let i = index">
    <ng-container *ngIf="message.openByDefault">
        <div
            [ngClass]="message.displayLevel + '-message'"
            [ngStyle]="{
                'margin-top': i > 0 ? '10px' : '0',
                'pointer-events': clickEvent ? 'auto' : 'none',
                height: height ? height : '40px'
            }"
            (click)="messageAction(message)"
        >
            <ngx-icon-box
                [icon]="getIcon(message.displayLevel)"
                [ngClass]="message.displayLevel + '-icon'"
            ></ngx-icon-box>
            <span [ngClass]="message.displayLevel + '-label'">{{ formatMessage(message) }}</span>
        </div>
    </ng-container>
</ng-container>
